import React from 'react';

import { Box } from '@mui/material';

import { EmailTrackerTableOnClearVerifyStaff } from 'src/components/emailTracker';
import { PaginationConfig } from 'src/providers/PaginationProvider';
import { TableDataProvider } from 'src/providers/TableDataProvider';
import { SxProp } from 'src/types/mui';

export const EmailTrackerPage: React.FC = () => {
  return (
    <Box sx={containerStyles}>
      <TableDataProvider
        paginationProviderProps={{
          paginationConfig: initialPaginationConfig,
        }}
      >
        <EmailTrackerTableOnClearVerifyStaff />
      </TableDataProvider>
    </Box>
  );
};

const initialPaginationConfig: PaginationConfig = {
  rowsPerPageOptions: [100, 500, 1000],
  rowsPerPage: 100,
};

const containerStyles: SxProp = {
  display: 'flex',
  flexGrow: 1,
  flexShrink: 1,
  flexBasic: '0%',
  flexDirection: 'column',
  height: '100%',
};
